<template>
  <figure class="my-20">
    <apexchart
      type="bar"
      height="500"
      :options="chartOptions"
      :series="series" />
  </figure>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'HorizontalBarChart',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    data: {
      // Example: [{ <label>: "...", <value>: 10 }]
      // Can define custom label/value in props below.
      type: Array,
      required: true,
    },
    labelKey: {
      type: String,
      default: 'label',
    },
    valueKey: {
      type: String,
      default: 'value',
    },
    seriesName: {
      type: String,
      default: '',
    },
  },
  computed: {
    labels() {
      return this.data.map(item => item[this.labelKey]);
    },
    values() {
      return this.data.map(item => item[this.valueKey]);
    },
    series() {
      return [
        {
          name: this.seriesName,
          data: this.values,
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 4,
            barHeight: '70%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
        },
        xaxis: {
          categories: this.labels,
        },
        tooltip: {
          shared: false,
          intersect: true,
        },
        legend: {
          show: false,
        },
      };
    },
  },
};
</script>
